import React, { Suspense } from 'react';
import { Switch, Router, Route } from 'react-router-dom';
import Loadable from 'react-loadable';
import { connect } from 'react-redux';

import '../../node_modules/font-awesome/scss/font-awesome.scss';

import { history } from '../_helpers';
import { alertActions, validateToken } from '../_actions';
import { PrivateRoute } from '../_components';
import PrivateRouteCMS from '../_components/PrivateRouteCMS';
import Loader from './layout/Loader';
import Aux from '../hoc/_Aux';
import ScrollToTop from './layout/ScrollToTop';
import withTracker from '../_components/GoogleAnalytics';

import Error404 from '../TaxworldTheme/HomepageV4/Error404';

// validate-token interval: Prod 5 min, Dev 1 min
const TOKEN_CHECK_INTERVAL = process.env.NODE_ENV === 'production' ? 5 * 60 * 1000 : 1 * 60 * 1000;

const ExternalRedirect = ({ to }) => {
  window.location.replace(`${process.env.REACT_APP_PUBLIC_WWW}${to}`);
  return null;
};

const LoginCMS = Loadable({
  loader: () => import('../TaxworldTheme/CMS/Login'),
  loading: Loader,
});

const FrontV4Layout = Loadable({
  loader: () => import('./layout/FrontV4Layout'),
  loading: Loader,
});

const HomepageV4Layout = Loadable({
  loader: () => import('./layout/HomepageV4Layout'),
  loading: Loader,
});

const AdminLayout = Loadable({
  loader: () => import('./layout/AdminLayout'),
  loading: Loader,
});

const ResetPasswordCMS = Loadable({
  loader: () => import('../TaxworldTheme/CMS/ResetPassword'),
  loading: Loader,
});

class App extends React.Component {
  constructor(props) {
    super(props);

    history.listen((location, action) => {
      this.props.clearAlerts();
    });
  }

  componentDidMount() {
    this.tokenInterval = setInterval(() => {
      const { user } = this.props;
      if (user && user.token) {
        this.props.validateTokenAction(user.token);
      }
    }, TOKEN_CHECK_INTERVAL); // 15 minutes
  }

  componentWillUnmount() {
    if (this.tokenInterval) {
      clearInterval(this.tokenInterval);
    }
  }

  render() {
    const { user } = this.props;

    return (
      <Router history={history}>
        <ScrollToTop>
          <Aux>
            <Suspense fallback={<Loader />}>
              {/*alert && alert.message && (
                <div className={`alert ${alert.type}`}>{alert.message}</div>
              )*/}
              <Switch>
                <Route exact path="/" render={() => <ExternalRedirect to="" />} />
                <Route exact path="/login" component={withTracker(FrontV4Layout, {} , user)}/>
                <Route exact path="/auth/google/callback" component={withTracker(FrontV4Layout, {} , user)}/>
                <Route exact path="/logout" component={withTracker(FrontV4Layout, {} , user)}/>
                <Route exact path="/reset-password/:token" component={withTracker(FrontV4Layout, {} , user)}/>
                <Route exact path="/reset-password" component={withTracker(FrontV4Layout, {} , user)}/>

                <Route exact path="/ezylia" render={() => <ExternalRedirect to="" />} />
                <Route exact path="/why-join" render={() => <ExternalRedirect to="" />} />
                <Route exact path="/membership" render={() => <ExternalRedirect to="membership" />} />
                <Route exact path="/company" render={() => <ExternalRedirect to="company" />} />
                <Route exact path="/publications" render={() => <ExternalRedirect to="publications" />} />
                <Route exact path="/events" render={() => <ExternalRedirect to="" />} />
                <Route exact path="/help" render={() => <ExternalRedirect to="" />} />

                <Route exact path="/resources/:slug" render={() => <ExternalRedirect to="resources" />} />
                <Route exact path="/resources" render={() => <ExternalRedirect to="resources" />} />

                <Route exact path="/trustpilot" component={withTracker(FrontV4Layout, {} , user)}/>
                <Route exact path="/engagebay" component={withTracker(FrontV4Layout, {} , user)}/>

                <Route exact path="/conditions-of-use" render={() => <ExternalRedirect to="conditions-of-use" />} />
                <Route exact path="/privacy-policy" render={() => <ExternalRedirect to="privacy-policy" />} />
                <Route exact path="/cookies-policy" render={() => <ExternalRedirect to="cookies-policy" />} />

                <Route exact path="/cms/reset-password" component={ResetPasswordCMS} />
                <Route exact path="/cms/login" component={LoginCMS} />
                <PrivateRouteCMS path="/cms" component={AdminLayout} />
                <PrivateRoute path="/" component={withTracker(HomepageV4Layout, {}, user)} />
                <Route path="*" component={withTracker(Error404, {}, user)} />
              </Switch>
            </Suspense>
          </Aux>
        </ScrollToTop>
      </Router>
    );
  }
}

const mapStateToProps = (state) => ({
  // NOTE: even though the alert render is commented out, this store subscription
  // is necessary. Without it, React Router v5 + connect() blocks re-renders during
  // navigation that only changes the slug (e.g. /topic/foo → /topic/bar).
  alert: state.alert, // DO NOT DELETE
  user: state.authentication.user,
  header: state.authentication.header,
});

const actionCreators = {
  clearAlerts: alertActions.clear,
  validateTokenAction: validateToken,
};

const connectedApp = connect(mapStateToProps, actionCreators)(App);
export { connectedApp as App };